import styled from "styled-components";
import { rgba } from "polished";

const SectionWrapper = styled.div`
  padding: 81px 0;
  h2 {
    padding-bottom: 40px;
  }
  overflow: hidden;
  @media only screen and (max-width: 1440px) {
    padding: 60px 0;
  }
  @media only screen and (max-width: 767px) {
    padding: 42px 0 12px;

    header {
      padding: 0 30px 40px;
    }
  }
  @media only screen and (max-width: 480px) {
    padding-bottom: 30px;
  }
`;

export const Container = styled.div`
  max-width: 1627px;
  margin: 0 auto;

  display: flex;
  align-items: center;

  @media only screen and (max-width: 1700px) {
    padding: 0 70px;
  }
  @media only screen and (max-width: 1360px) {
    padding: 0 30px;
  }
  @media only screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const ImageWrapper = styled.div`
  width: calc(90% - 507px);

  @media only screen and (max-width: 991px) {
    padding-left: 50px;
  }
  @media only screen and (max-width: 767px) {
    padding-left: 0;
    width: 100%;
  }
`;

export const TextWrapper = styled.div`
  width: 507px;
  padding-right: 75px;
  position: relative;
  padding-left:40px;
  
  @media only screen and (max-width: 1200px) {
    width: 60%;
    padding-right: 50px;
    padding-left:0px;
  }
  @media only screen and (max-width: 991px) {
    padding-right: 0;
    padding-left:0px;
  }
  @media only screen and (max-width: 767px) {
    width: 100%;
    padding-right: 0;
    margin-bottom: 30px;
    padding-left:20px;
  }
  h2 {
    @media only screen and (min-width: 1441px) {
      margin-bottom: 60px;
    }
    @media only screen and (min-width: 1440px) {
      margin-bottom: 40px;
    }
    @media only screen and (min-width: 767px) {
      margin-bottom: 30px;
    }
  }
  h3 {
    font-weight:500;
    margin: 0 0 16px;
    @media only screen and (max-width: 1360px) {
      font-size: 24px;
      margin: 0 0 12px;
    }
    @media only screen and (max-width: 480px) {
      line-height: 34px;
      margin-bottom: 7px;
    }
  }

  p {
    margin-bottom: 30px;
  }

  .learn__more-btn {
    margin-top: 20px;
  }
  span {
    color: ${rgba("#00A5C0", 1)};
    font-size: 64px;
    line-height: 1em;
    font-family: "Jost", sans-serif;
    width: 100px;
    flex-shrink: 0;
    padding-top: 10px;
    display: block;
    @media only screen and (max-width: 1600px) {
      font-size: 55px;
      width: 80px;
    }
`;

export default SectionWrapper;
